import React from 'react'
import styled from 'styled-components'

const ItemRow = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-bottom: 14px;
    line-height: 1.4;
    text-transform: capitalize;
`

const ItemLabel = styled.div`
    width: 200px;
    color: #999;
    font-size: 14px;
    margin-bottom: 4px;
`

const ItemValue = styled.div.withConfig({
    shouldForwardProp: (prop) => prop !== 'emphasize',
})`
    font-size: 14px;
    font-weight: 500;
    color: ${props => (props.emphasize ? 'red' : '#000')};
`

export const Item = ({
    label,
    value,
    emphasize,
    emphasizeExceptions = [],
    style,
}) => {
    const shouldEmphasize = Boolean(
        emphasize && !emphasizeExceptions.includes(value.trim().toLowerCase())
    )

    return (
        <ItemRow style={style}>
            <ItemLabel>{label}</ItemLabel>
            <ItemValue emphasize={shouldEmphasize}>{value}</ItemValue>
        </ItemRow>
    )
}
